import password from "./types/password";
import select from "./types/select";
import text from "./types/text";
import number from "./types/number";
const InputTypes = {
    text, password, select, number  
}
export default InputTypes;